import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hxncymjum6: FaireBrandEntity = {
  token: "b_hxncymjum6",
  type: "brand",
  name: "Phenomenal Fudge",
  avatarUrl:
    "https://cdn.faire.com/fastly/3b8647a8aaa4e18e76d49c41b815ab05a83707becf2144580f914d94fe53311a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c0e60bdc9d5c8964a7dc1c79aa1865456fc3b703134f3fc43e4919b7319c0fea.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3b8647a8aaa4e18e76d49c41b815ab05a83707becf2144580f914d94fe53311a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c0e60bdc9d5c8964a7dc1c79aa1865456fc3b703134f3fc43e4919b7319c0fea.jpeg",
  location: "Shoreham, VT, USA",
  minimumOrderDollars: 139,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "In 1985 we opened a country store in Middlebury, Vermont. We focused on marketing Vermont homemade products. It wasn’t long before we were selling more of our fudge than Vermont maple syrup.In 1996 we closed the store to focus solely on the fudge business. \n\nOver the years our market has grown substantially but our fudge has remained absolutely the same: soft, creamy and utterly phenomenal tasting. We are dedicated to providing fast, affordable and quite literally, the most phenomenal fudge you’ve ever had.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:42.452Z",
    importedBy: "entity-db-cli",
  },
};
